import axios from 'axios';

const api = '/api/insurance-companies';

export const getAllLightCompanies = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};

export const getAllCompanies = () => {
  return axios.get(`${api}/full?cacheBuster=${new Date().getTime()}`);
};

export const getById = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const create = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const update = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};

export const getLightCompaniesWithIban = () => {
  return axios.get(`${api}/withIban?cacheBuster=${new Date().getTime()}`);
};

export const uploadLogo = (companyId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  return axios.post(`${api}/upload/${companyId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const downloadLogo = async companyId => {
  const response = await axios.get(`${api}/download/${companyId}`, {
    responseType: 'blob', // Important for binary data
  });

  const blob = new Blob([response.data], { type: response.data.type });
  return window.URL.createObjectURL(blob);
};
